import { useSupportAccessSession } from "hooks/useSupportAccessSession";

/**
 * A fixed border around the whole viewport while a support session is active.
 *
 * WHY, given there is already a bar: screenshots. Support work generates
 * cropped screenshots pasted into tickets, and a crop that excludes the top of
 * the window loses the bar entirely — so an image showing a customer's
 * financial data carries no indication it was taken from inside a staff
 * session. A frame is present at every edge, so any crop that contains content
 * also contains evidence of the session.
 *
 * `pointer-events: none` is load-bearing: this sits above the entire
 * application, and without it the frame would swallow clicks along every edge.
 */
export function SupportAccessFrame() {
	const { session } = useSupportAccessSession();
	if (session?.active !== true) return null;

	return (
		<div aria-hidden data-testid="support-access-frame" style={frameStyle} />
	);
}

const frameStyle: React.CSSProperties = {
	position: "fixed",
	inset: 0,
	border: "3px solid #7c3aed",
	// Above the bar (1100) and everything AntD renders, because it must survive
	// a modal being open.
	zIndex: 2000,
	// Never intercept a click. The frame is evidence, not a control.
	pointerEvents: "none",
};
